import "./App.css";
import Search from "./Search";

function App() {
  return (
    <div className="App">
      <div className="container">
        <Search />
      </div>
    </div>
  );
}

export default App;
